module.exports = __webpack_public_path__ + "media/images/features/draft/hr-faq-9c95eef4d2058b07f4f541c4e606c76b.svg";